<template>
  <div class="pbbox" v-if="kpi && shouldShow()">
    <div class="pbnps">
      <p>{{ getLastWave.Name }}</p>
      <p>n={{ getLastWave.NumberOfShopsTotal }}</p>
    </div>
    <div>
      <table class="pbrow">
        <tbody>
          <tr>
            <td class="pbpros" v-bind:style="{ width: getPromoters + '%' }"></td>
            <td class="pbntrl" v-bind:style="{ width: getNeutrals + '%' }"></td>
            <td class="pbcons" v-bind:style="{ width: getDetractors + '%' }"></td>
          </tr>
        </tbody>
      </table>
      <div class="pbrow narrow_025">
        <p style="float: left;">{{ getPromoters }}% {{ $t('Webportal.DashboardBMW.Promoters') }}</p>
        <p style="float: right;">{{ getDetractors }}% {{ $t('Webportal.DashboardBMW.Detractors') }}</p>
      </div>
    </div>

  </div>
</template>

<script>

  export default {
    name: 'NpsBar',

    props:{
      kpi: { type: Object, default: undefined }
    },

    methods: {
      shouldShow () {
        let item = this.getLastWave;
        if (!item) { return false; }
        if ('NumberOfShopsTotal' in item && 'NumberOfShopsTotal' in item && 'ResultDetractors' in item) { return true; }
        return false;
      }
    },

    computed:{
      getLastWave: function () {
        return _.last(this.kpi.SurveyWave);
      },
      getPromoters: function () {
        return this.getLastWave.ResultPromoters;
      },
      getDetractors: function () {
        return this.getLastWave.ResultDetractors;
      },
      getNeutrals: function () {
        return 100 - this.getLastWave.ResultDetractors - this.getLastWave.ResultPromoters;
      },



    }
  }

</script>


<style scoped>
  p{
    font-size: 8pt;
    font-stretch: extra-condensed;
    margin-bottom:0px;
    margin-left: 3px;
    line-height: 0.7rem;
  }
  td{
       line-height: 0.7rem;
  }
.pbpros, .pbcons, .pbntrl {
  font-size: 8pt;
  height: 0.7rem;
  vertical-align: middle;
  text-align: center;
  color: whitesmoke;

}
.pbpros {
  background-color:#3C6937;
  text-align: center;

}
.pbcons {
  background-color:#C20003;
}
.pbntrl {
  background-color:#7F7F7F;
}
.pbrow {
  float: left;
  width: 75%;
  border-spacing: 0px;
}
.pbnps{
  float: left;
  width: 25%;
}
.pbbox{
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
  height: 1.3rem;

}
</style>
